module.exports = __webpack_public_path__ + "img/pop-up-Emoji.f89f0072.svg";